module.exports = __webpack_public_path__ + "1432ab486aaa3d7f920819d4ed148314.svg";